import { render, staticRenderFns } from "./multipleSelect.vue?vue&type=template&id=c72161fc"
import script from "./multipleSelect.vue?vue&type=script&lang=js"
export * from "./multipleSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports